module.exports = __webpack_public_path__ + "img/logo-landscape.7c94a292.png";